/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';
import { Configure, Index, InstantSearch, connectSearchBox } from 'react-instantsearch-dom';

import { getUserLanguageCode } from 'js/lib/language';
import useRouter from 'js/lib/useRouter';

import {
  ALGOLIA_ENTERPRISE_SHORT_FORM_CONTENT_INDEX,
  ENTERPRISE_AUTOCOMPLETE_HITS_PER_PAGE_CLIPS_EXPERIMENT,
  SHORT_FORM_CONTENT_VIDEO_ENTITY_TYPE_DESCRIPTION,
} from 'bundles/enterprise-learner-search/constants';
import { getCustomSearchClientBySearchInPrograms } from 'bundles/enterprise-legacy-learner-home/utils/SearchUtils';

export type PropsFromCaller = {
  skills: Array<string>;
  programId?: string;
};

const VirtualSearchBox = connectSearchBox(() => null);

export const RelatedVideosSearchWrapper: React.LegacyFunctionComponentWithChildren<PropsFromCaller> = ({
  skills,
  programId,
  children,
}) => {
  const router = useRouter();
  const {
    location: { query },
  } = router;
  const { query: currentQuery } = query;
  const userLanguageCode = getUserLanguageCode();

  const facetFilters = [
    [`entityTypeDescription:${SHORT_FORM_CONTENT_VIDEO_ENTITY_TYPE_DESCRIPTION}`],
    [`languageCode:${userLanguageCode.split('-')[0]}`],
    skills ? skills.map((skill) => `skills:${skill}`) : [],
  ];

  if (!programId || !currentQuery) {
    return <React.Fragment>{children}</React.Fragment>;
  }

  return (
    // @ts-expect-error TS2769: No overload matches this call. ... Property `children` does not exist on type `IntrinsicAttributes & (IntrinsicClassAttributes<InstantSearch> & Readonly<InstantSearchProps>)`
    <InstantSearch
      searchClient={getCustomSearchClientBySearchInPrograms([programId], true)}
      indexName={ALGOLIA_ENTERPRISE_SHORT_FORM_CONTENT_INDEX}
      searchState={{ query: currentQuery }}
    >
      <Index
        key={ALGOLIA_ENTERPRISE_SHORT_FORM_CONTENT_INDEX}
        indexName={ALGOLIA_ENTERPRISE_SHORT_FORM_CONTENT_INDEX}
        indexPosition={0}
      >
        <Configure hitsPerPage={ENTERPRISE_AUTOCOMPLETE_HITS_PER_PAGE_CLIPS_EXPERIMENT} facetFilters={facetFilters} />
      </Index>
      <VirtualSearchBox />
      {children}
    </InstantSearch>
  );
};
